import { z } from 'zod';
import { baseMessageSchema, createMessageId } from './_base';
import { gameSaveStorageReplySchema, gameSaveStorageRequestSchema } from '../validators/gameSave';
import type { NativeGameSaveStorageReply, NativeGameSaveStorageRequest } from '../types';

export enum GameSaveStorageMessageType {
  HOST_GAME_SAVE_STORAGE_REQUEST = 'HOST_GAME_SAVE_STORAGE_REQUEST',
  HOST_GAME_SAVE_STORAGE_REPLY = 'HOST_GAME_SAVE_STORAGE_REPLY',
}
const requestSchema = baseMessageSchema.extend({
  type: z.literal(GameSaveStorageMessageType.HOST_GAME_SAVE_STORAGE_REQUEST), request: gameSaveStorageRequestSchema,
});
const replySchema = baseMessageSchema.extend({
  type: z.literal(GameSaveStorageMessageType.HOST_GAME_SAVE_STORAGE_REPLY), reply: gameSaveStorageReplySchema,
});
export const hostGameSaveStorageMessageSchema = z.discriminatedUnion('type', [requestSchema, replySchema]);
export type HostGameSaveStorageMessage = z.infer<typeof hostGameSaveStorageMessageSchema>;

export function generateGameSaveStorageRequest(request: NativeGameSaveStorageRequest): HostGameSaveStorageMessage {
  return requestSchema.parse({ id: createMessageId(), timestamp: Date.now(),
    type: GameSaveStorageMessageType.HOST_GAME_SAVE_STORAGE_REQUEST, request });
}
export function generateGameSaveStorageReply(reply: NativeGameSaveStorageReply): HostGameSaveStorageMessage {
  return replySchema.parse({ id: createMessageId(), timestamp: Date.now(),
    type: GameSaveStorageMessageType.HOST_GAME_SAVE_STORAGE_REPLY, reply });
}
